import type { AppRouteRecordRaw } from 'common/router/type'
import type { Router } from 'vue-router'
import { env } from 'common/utils/env'

// 替代 es-toolkit 的 mapKeys 方法
const mapKeys = <T>(
  obj: Record<string, T>,
  fn: (value: T, key: string) => string
): Record<string, T> => {
  const result: Record<string, T> = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = fn(obj[key], key)
      result[newKey] = obj[key]
    }
  }
  return result
}

/**
 * 静态路由
 */
const defaultRoutes: AppRouteRecordRaw[] = [
  {
    path: '/expired',
    name: 'expired',
    component: () => import('@/pages/results/expired.vue')
  },
  {
    path: '/success',
    name: 'success',
    component: () => import('@/pages/results/success.vue')
  },
  {
    path: '/mpesaError',
    name: 'mpesaError',
    component: () => import('@/pages/results/mpesaError.vue')
  },
  {
    path: '/mpesaSuccess',
    name: 'mpesaSuccess',
    component: () => import('@/pages/results/mpesaSuccess.vue')
  },
  {
    path: '/orbitPaySuccess',
    name: 'orbitPaySuccess',
    component: () => import('@/pages/results/orbitPaySuccess.vue')
  }
]
/**
 * 注入静态路由
 * @param router
 */
export const setStaticRoute = (router: Router) => {
  defaultRoutes.forEach(route => {
    router.addRoute(route)
  })
}

// 获取页面组件（兼容 Vite 与 webpack 两种构建环境）
const getDynamicPageModules = () => {
  const res: Record<string, any> = {}

  // Vite 环境：使用 import.meta.glob
  if (env.isUseVite) {
    // @ts-expect-error import.meta.glob 是 Vite 专属，webpack(CommonJS) 不支持
    const modules = (import.meta as any).glob(
      '../pages/product/**/index.ts',
      { eager: true },
    )
    Object.entries(modules).forEach(([key, mod]: [string, any]) => {
      const route = mod.route || mod.default?.route || mod.default
      if (route) {
        res[key] = route
      }
    })
    return res
  }

  // webpack 环境：使用 require.context
  const ctx = (require as any).context(`@/pages/product`, true, /index\.ts$/)
  ctx.keys().forEach((key: string) => {
    const module = ctx(key)
    const route = module.route || module.default?.route || module.default
    if (route) {
      res[key] = route
    }
  })
  return res
}

const dynamicPageModuleMap = mapKeys(getDynamicPageModules(), (value, key) => {
  // webpack key: ./razer/index.ts
  // Vite key:    /src/project/pages/product/razer/index.ts
  // 取倒数第二段（产品目录名）作为路由名称
  const segments = key.split('/')
  return segments[segments.length - 2]
})
const setDynamicRoute = (router: Router) => {
  Object.entries(dynamicPageModuleMap).forEach(config => {
    const _name = config[0]
    const _route = config[1] as AppRouteRecordRaw
    router.addRoute({
      name: _name,
      path: _route.path,
      component: _route.component
    } as AppRouteRecordRaw)
  })
}

export const initRouter = (router: Router) => {
  setStaticRoute(router)
  setDynamicRoute(router)
}
